"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _proskommaJsonTools = require("proskomma-json-tools");

var _excluded = ["hs"];

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ = require("lodash");
/**
 * PERF Middleware for Editors in the Proskomma Ecosystem
 * @class
 */


class Epitelete {
  /**
   * @param {Object} args - constructor args
   * @param {Proskomma} [args.proskomma] - a proskomma instance
   * @param {number} args.docSetId - a docSetId
   * @param {object} [args.options={}] - setting params
   * @param {number} [args.options.historySize=10] - size of history buffer
   * @return {Epitelete} Epitelete instance
   */
  constructor(_ref) {
    var {
      proskomma = null,
      docSetId,
      options = {}
    } = _ref;

    if (!docSetId) {
      throw new Error("docSetId is required");
    }

    var query = "{ docSet(id: \"".concat(docSetId, "\") { id } }");
    var {
      data: gqlResult
    } = (proskomma === null || proskomma === void 0 ? void 0 : proskomma.gqlQuerySync(query)) || {};

    if (proskomma && !(gqlResult !== null && gqlResult !== void 0 && gqlResult.docSet)) {
      throw new Error("Provided docSetId is not present in the Proskomma instance.");
    }

    var knownOptions = new Set(['historySize']);
    var unknownOptions = Object.keys(options).filter(o => !knownOptions.has(o));

    if (unknownOptions.length > 0) {
      throw new Error("Unknown options in constructor: ".concat(unknownOptions.join(', ')));
    }

    var {
      hs
    } = options,
        opt = _objectWithoutProperties(options, _excluded);

    var historySize = hs ? hs + 1 : 11; //add one to passed history size so it matches undos allowed.

    this.options = _objectSpread({
      historySize
    }, opt);
    this.proskomma = proskomma;
    this.docSetId = docSetId;
    this.history = {};
    this.validator = new _proskommaJsonTools.Validator();
    this.backend = proskomma ? 'proskomma' : 'standalone';
  }
  /**
   * Gets a copy of a document from history
   * @private
   * @param {string} bookCode
   * @return {perfDocument} matching PERF document
   */


  getDocument(bookCode) {
    var history = this.history[bookCode];
    return _.cloneDeep(history === null || history === void 0 ? void 0 : history.stack[history.cursor]);
  }
  /**
   * Gets documents copies from history
   * @private
   * @return {Object<bookCode,perfDocument>} Object with book code as key and PERF document as value
   */


  getDocuments() {
    return Object.keys(this.history).reduce((documents, bookCode) => {
      documents[bookCode] = this.getDocument(bookCode);
      return documents;
    }, {});
  }
  /**
   * Adds new document to history (replaces any doc with same bookCode already in history)
   * @param {string} bookCode
   * @param {perfDocument} doc
   * @return {perfDocument} same passed PERF document
   * @private
   */


  addDocument(bookCode, doc) {
    this.history[bookCode] = {
      stack: [_.cloneDeep(doc)],
      //save a copy of the given doc in memory
      cursor: 0
    };
    return doc;
  }
  /**
   * Fetches document from proskomma instance
   * @async
   * @param {string} bookCode
   * @return {Promise<perfDocument>} fetched PERF document
   */


  fetchPerf(bookCode) {
    var _this = this;

    return _asyncToGenerator(function* () {
      if (_this.backend === "standalone") {
        throw "Can't call sideloadPerf in standalone mode";
      }

      if (!bookCode) {
        throw new Error("fetchPerf requires 1 argument (bookCode)");
      }

      var query = "{docSet(id: \"".concat(_this.docSetId, "\") { document(bookCode: \"").concat(bookCode, "\") { perf } } }");

      var {
        data
      } = _this.proskomma.gqlQuerySync(query);

      var queryResult = data.docSet.document.perf;

      if (!queryResult) {
        throw new Error("No document with bookCode=\"".concat(bookCode, "\" found."));
      }

      var perfDocument = JSON.parse(queryResult);
      return _this.addDocument(bookCode, perfDocument);
    })();
  }
  /**
   * Gets document from memory or fetches it if proskomma is set
   * @async
   * @param {string} bookCode
   * @return {Promise<perfDocument>} found or fetched PERF document
   */


  readPerf(bookCode) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      if (!_this2.history[bookCode] && _this2.backend === "proskomma") {
        return _this2.fetchPerf(bookCode);
      }

      if (!_this2.history[bookCode] && _this2.backend === "standalone") {
        throw "No document with bookCode=\"".concat(bookCode, "\" found in memory. Use sideloadPerf() to load the document.");
      }

      return _this2.getDocument(bookCode);
    })();
  }
  /**
   * Merges a sequence with the document and saves the new modified document.
   * @param {string} bookCode
   * @param {number} sequenceId - id of modified sequence
   * @param {perfSequence} perfSequence - modified sequence
   * @return {perfDocument} modified PERF document
   */


  writePerf(bookCode, sequenceId, perfSequence) {
    // Get copy of last doc from memory
    var doc = this.getDocument(bookCode);

    if (!doc) {
      throw "document not found: ".concat(bookCode);
    } // if not found throw error


    if (!doc.sequences[sequenceId]) {
      throw "PERF sequence id not found: ".concat(bookCode, ", ").concat(sequenceId);
    } // validate new perf sequence


    var validatorResult = this.validator.validate('constraint', 'perfSequence', '0.2.1', perfSequence); // if not valid throw error

    if (!validatorResult.isValid) {
      throw "PERF sequence  ".concat(sequenceId, " for ").concat(bookCode, " is not valid: ").concat(JSON.stringify(validatorResult));
    } // if valid
    // modify the copy to add new sequence


    doc.sequences[sequenceId] = _.cloneDeep(perfSequence);
    var history = this.history[bookCode]; // remove any old redo's from stack

    history.stack = history.stack.slice(history.cursor); // add modified copy to stack

    history.stack.unshift(doc);
    history.cursor = 0; // limit history.stack to options.historySize

    if (history.stack.length > this.options.historySize) history.stack.pop(); // return copy of modified document

    return _.cloneDeep(doc);
  }
  /**
   * ?Checks Perf Sequence
   * @param {perfSequence} perfSequence
   * @return {string[]} array of warnings
   */


  checkPerfSequence(perfSequence) {
    var currentChapter = 0;
    var currentVerse = 0;
    var warnings = perfSequence === null || perfSequence === void 0 ? void 0 : perfSequence.blocks.reduce((warnings, _ref2) => {
      var {
        content: blockContent
      } = _ref2;

      if (Array.isArray(blockContent)) {
        for (var contentBlock of blockContent) {
          if (contentBlock.type === 'mark' && contentBlock.subtype === 'verses') {
            currentVerse++;

            if (currentVerse.toString() !== contentBlock.atts.number) {
              warnings.push("Verse ".concat(contentBlock.atts.number, " is out of order, expected ").concat(currentVerse));
              currentVerse = Number(contentBlock.atts.number);
            }
          }

          if (contentBlock.type === 'mark' && contentBlock.subtype === 'chapter') {
            currentChapter++;

            if (currentChapter.toString() !== contentBlock.atts.number) {
              warnings.push("Chapter ".concat(contentBlock.atts.number, " is out of order, expected ").concat(currentChapter));
              currentChapter = Number(contentBlock.atts.number);
            }

            currentVerse = 0;
          }
        }
      }

      return warnings;
    }, []);
    return warnings;
  }
  /**
   * Get array of book codes from history
   * @return {string[]} array of bookCodes
   */


  localBookCodes() {
    return Object.keys(this.history);
  }
  /**
   * Gets the available books for current docSet.
   * @return {{}} an object with book codes as keys, and values
   * contain book header data
   */


  bookHeaders() {
    var _this$proskomma, _gqlResult$docSet;

    var documentHeaders = {};
    var query = "{ docSet(id: \"".concat(this.docSetId, "\") { documents { headers { key value } } } }");
    var {
      data: gqlResult
    } = ((_this$proskomma = this.proskomma) === null || _this$proskomma === void 0 ? void 0 : _this$proskomma.gqlQuerySync(query)) || {};
    var documents = (gqlResult === null || gqlResult === void 0 ? void 0 : (_gqlResult$docSet = gqlResult.docSet) === null || _gqlResult$docSet === void 0 ? void 0 : _gqlResult$docSet.documents) || this.getDocuments();

    for (var document of documents) {
      var key = null;
      var headers = {};

      for (var header of document.headers) {
        if (header.key === 'bookCode') {
          key = header.value;
        } else {
          headers[header.key] = header.value;
        }
      }

      if (key) {
        documentHeaders[key] = headers;
      }
    }

    return documentHeaders;
  }
  /**
   * Clears docs history
   * @return {void} void
   */


  clearPerf() {
    this.history = {};
  }
  /**
   * Checks if able to undo from specific book history
   * @param {string} bookCode
   * @return {boolean}
   */


  canUndo(bookCode) {
    var history = this.history[bookCode];
    if (!history) return false;
    if (history.cursor + 1 === history.stack.length) return false;
    return true;
  }
  /**
   * Checks if able to redo from specific book history
   * @param {string} bookCode
   * @return {boolean}
   */


  canRedo(bookCode) {
    var history = this.history[bookCode];
    if (!history) return false;
    if (history.cursor === 0) return false;
    return true;
  }
  /**
   * Gets previous document from history
   * @param {string} bookCode
   * @return {?perfDocument} PERF document or null if can not undo
   */


  undoPerf(bookCode) {
    if (this.canUndo(bookCode)) {
      var history = this.history[bookCode];
      var cursor = ++history.cursor;
      var doc = history.stack[cursor];
      return _.cloneDeep(doc);
    }

    return null;
  }
  /**
   * Gets next document from history
   * @param {string} bookCode
   * @return {?perfDocument} PERF document or null if can not redo
   */


  redoPerf(bookCode) {
    if (this.canRedo(bookCode)) {
      var history = this.history[bookCode];
      var cursor = --history.cursor;
      var doc = history.stack[cursor];
      return _.cloneDeep(doc);
    }

    return null;
  }
  /**
   * Loads given perf into memory
   * @param {string} bookCode
   * @param {perfDocument} perfDocument - PERF document
   * @return {perfDocument} same sideloaded PERF document
   */


  sideloadPerf(bookCode, perfDocument) {
    if (this.backend === "proskomma") {
      throw "Can't call sideloadPerf in proskomma mode";
    }

    if (!bookCode || !perfDocument) {
      throw "sideloadPerf requires 2 arguments (bookCode, perfDocument)";
    }

    var validatorResult = this.validator.validate('constraint', 'perfDocument', '0.2.1', perfDocument);

    if (!validatorResult.isValid) {
      throw "perfJSON is not valid. \n".concat(JSON.stringify(validatorResult, null, 2));
    }

    return this.addDocument(bookCode, perfDocument);
  }
  /**
   * Gets document from memory and converts it to usfm
   * @async
   * @param {string} bookCode
   * @return {string} converted usfm
   */


  readUsfm(bookCode) {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      var perf = yield _this3.readPerf(bookCode);
      var renderer = new _proskommaJsonTools.ProskommaRenderFromJson({
        srcJson: perf,
        actions: _proskommaJsonTools.toUsfmActions
      });
      var output = {};
      renderer.renderDocument({
        docId: "",
        config: {},
        output
      });
      return output.usfm;
    })();
  }

}

var _default = Epitelete;
/**
 * @typedef {object} contentElementPerf
 * @property {string} type
 * @property {string} [number]
 * @property {"verses"|"xref"|"footnote"|"noteCaller"} [subType]
 * @property {string} [target]
 * @property {number} [nBlocks]
 * @property {string} [previewText]
 */

/**
 * @typedef {object} blockOrGraftPerf
 * @property {"block"|"graft"} type
 * @property {string} subType
 * @property {string} [target]
 * @property {number} [nBlocks]
 * @property {string} [previewText]
 * @property {string} [firstBlockScope]
 * @property {Array<string|contentElementPerf>} [content]
 */

/**
 * @typedef {object} perfSequence
 * @property {"main"|"introduction"|"introTitle"|"IntroEndTitle"|"title"|"endTitle"|"heading"|"remark"|"sidebar"|"table"|"tree"|"kv"|"footnote"|"noteCaller"|"xref"|"pubNumber"|"altNumber"|"esbCat"|"fig"|"temp"} type
 * @property {number} [nBlocks]
 * @property {string} [firstBlockScope]
 * @property {string} [previewText]
 * @property {boolean} selected
 * @property {blockOrGraftPerf[]} [blocks]
 */

/**
 * @typedef {object} perfDocument
 * @property {object} headers
 * @property {array} tags
 * @property {Object<string,perfSequence>} sequences
 * @property {string} mainSequence
 */

/**
 * Proskomma instance
 * @typedef Proskomma
 * @see {@link https://github.com/mvahowe/proskomma-js}
 */

exports.default = _default;